services.factory('CurrencyConvertService', ['constants', 'UserService',
    function (Const, UserService) {
        var usdRe = new RegExp(/USD/);
        var user = UserService.get();

        function find(AssetService, fromCurrency, toCurrency, ending, profitMode, isNotFound) {
            var result = [];
            var loggedIn = UserService.get().loggedIn;
            if (loggedIn && !isNotFound) return convert(AssetService, fromCurrency, toCurrency, ending, profitMode);
            //from/to operation: true-*, false-/

            if (fromCurrency === toCurrency) return result;

            var ruleFromDirect = {
                s: fromCurrency + Const.currencySeparator + toCurrency + ending,
            };

            var ruleFromInvert = _.assign({}, ruleFromDirect, {
                s: toCurrency + Const.currencySeparator + fromCurrency + ending
            });

            var fromAsset = AssetService.collection.get(ruleFromDirect);
            var fromOperation = true;
            if (!fromAsset) {
                fromAsset = AssetService.collection.get(ruleFromInvert);
                fromOperation = false;
            }

            if (fromAsset) {
                result.push({
                    asset: fromAsset,
                    reverse: fromOperation
                });
                return result;
            }

            if (fromCurrency !== 'USD') {
                //get asset for fromCurrency
                fromAsset = AssetService.collection.get({s: 'USD' + Const.currencySeparator + fromCurrency + ending});
                fromOperation = false;
                //if fromAsset not found - looking for reverse asset and set fromOperation to false
                if (!fromAsset) {
                    fromAsset = AssetService.collection.get({s: fromCurrency + Const.currencySeparator + 'USD' + ending});
                    fromOperation = true;
                }

                if (!fromAsset) {
                    console.warn('NOT FOUND FROM_ASSET:', fromCurrency, toCurrency, ending, profitMode);
                    throw new Error('FROM_ASSET IS NOT FOUND');
                }

                result.push({
                    asset: fromAsset,
                    reverse: fromOperation,
                    isUSD: usdRe.test(fromAsset.s)
                })
            }

            if (toCurrency !== 'USD') {
                //get asset for toCurrency
                var toAsset = AssetService.collection.get({s: 'USD' + Const.currencySeparator + toCurrency + ending});
                var toOperation = true;
                //if toAsset not found - looking for reverse asset and set toOperation to false
                if (!toAsset) {
                    toAsset = AssetService.collection.get({s: toCurrency + Const.currencySeparator + 'USD' + ending});
                    toOperation = false;
                }

                if (!toAsset) {
                    console.warn('NOT FOUND TO_ASSET:', fromCurrency, toCurrency, ending, profitMode);
                    //throw new Error('TO_ASSET IS NOT FOUND');
                }

                result.push({
                    asset: toAsset,
                    reverse: toOperation,
                    isUSD: usdRe.test(toAsset.s)
                })
            }

            return result;
        }


        function currencyConvert(AssetService, fromCurrency, toCurrency, amount, action, profitMode, isNotFound) {
            var loggedIn = UserService.get().loggedIn;
            if (loggedIn && !isNotFound) return convert(fromCurrency, toCurrency, amount, action, profitMode);

            var resultAmount = amount;
            var direction = action.match(/^buy/) ? 'Bid' : 'Ask';

            //from/to operation: true-*, false-/

            if (fromCurrency !== 'USD') {
                //get asset for fromCurrency
                var fromAsset = AssetService.collection.get({s: 'USD' + Const.currencySeparator + fromCurrency});
                var fromOperation = false;
                //if fromAsset not found - looking for reverse asset and set fromOperation to false
                if (!fromAsset) {
                    fromAsset = AssetService.collection.get({s: fromCurrency + Const.currencySeparator + 'USD'});
                    fromOperation = true;
                }
                resultAmount = fromOperation
                    ? (amount * fromAsset['markup' + direction]())
                    : (amount / fromAsset['markup' + direction]());
            }

            if (toCurrency !== 'USD') {
                //get asset for toCurrency
                var toAsset = AssetService.collection.get({s: 'USD' + Const.currencySeparator + toCurrency});
                var toOperation = true;
                //if toAsset not found - looking for reverse asset and set toOperation to false
                if (!toAsset) {
                    toAsset = AssetService.collection.get({s: toCurrency + Const.currencySeparator + 'USD'});
                    toOperation = false;
                }
                resultAmount = toOperation
                    ? (resultAmount * toAsset['markup' + direction]())
                    : (resultAmount / toAsset['markup' + direction]());
            }

            return resultAmount;
        }

        function convert(AssetService, fromCurrency, toCurrency, ending, profitMode, category) {
            var result = [];
            var isForexAsset = profitMode === 0;

            var currencyConvertCategory = Const['defaultCurrencyConvertCategory'] || 'FOREX';
            if(user.activeTradingAccount && user.activeTradingAccount.isCryptoCurrency !== undefined) {
                currencyConvertCategory = user.activeTradingAccount.isCryptoCurrency ? 'CRYPTO':  'FOREX';
            }

            if (fromCurrency === toCurrency) return result;

            var ruleFrom = {
                s: fromCurrency + Const.currencySeparator + toCurrency + ending,
                isClient: true
            };

            var ruleFromDirect = isForexAsset ? _.assign({}, ruleFrom, {category: category || currencyConvertCategory})
                                              : _.assign({}, ruleFrom, {});
            var ruleFromInvert = _.assign({}, ruleFromDirect, {s: toCurrency + Const.currencySeparator + fromCurrency + ending});

            var fromAsset = AssetService.collection.get(ruleFromDirect);
            var fromOperation = true;
            if (!fromAsset) {
                fromAsset = AssetService.collection.get(ruleFromInvert);
                fromOperation = false;
            }

            if (fromAsset) {
                result.push({
                    asset: fromAsset,
                    reverse: fromOperation
                });
                return result;
            }

            if (!category) {
                return convert(AssetService, fromCurrency, toCurrency, ending, profitMode, 'FOREX');
            }

            //if no asset found - run convertUSD
            return convertUSD(AssetService, fromCurrency, toCurrency, ending, profitMode);
        }

        function convertUSD(AssetService, fromCurrency, toCurrency, ending, profitMode) {
            var result = [];
            var isForexAsset = profitMode === 0;

            if (fromCurrency !== 'USD') {
                var ruleFrom = {
                    s: fromCurrency + Const.currencySeparator + 'USD' + ending,
                    isClient: true
                };

                var ruleFromDirect = isForexAsset ? _.assign({}, ruleFrom, {category: 'FOREX'}) : _.assign({}, ruleFrom, {});
                var ruleFromInvert = _.assign({}, ruleFromDirect, {s: 'USD' + Const.currencySeparator + fromCurrency + ending});

                var fromAsset = AssetService.collection.get(ruleFromDirect);
                var fromOperation = true;
                if (!fromAsset) {
                    fromAsset = AssetService.collection.get(ruleFromInvert);
                    fromOperation = false;
                }

                //not found
                if (!fromAsset) {
                    return find(AssetService, fromCurrency, toCurrency, ending, profitMode, true);
                }

                result.push({
                    asset: fromAsset,
                    reverse: fromOperation,
                    isUSD: true
                })
            }

            if (toCurrency !== 'USD') {
                var ruleTo = {
                    s: 'USD' + Const.currencySeparator + toCurrency + ending,
                    isClient: true
                };

                var ruleToDirect = isForexAsset ? _.assign({}, ruleTo, {category: 'FOREX'}) : _.assign({}, ruleTo, {});
                var ruleToInvert = _.assign({}, ruleToDirect, {s: toCurrency + Const.currencySeparator + 'USD' + ending});

                var toAsset = AssetService.collection.get(ruleToDirect);
                var toOperation = true;
                if (!toAsset) {
                    toAsset = AssetService.collection.get(ruleToInvert);
                    toOperation = false;
                }

                //not found
                if (!toAsset) {
                    return find(AssetService, fromCurrency, toCurrency, ending, profitMode, true);
                }

                result.push({
                    asset: toAsset,
                    reverse: toOperation,
                    isUSD: true
                })
            }

            return result;
        }

        /**
         * Returns price according to asset profit mode
         */
        function getValue(asset, action, profitMode, isUSD) {
            //direct conversion
            if (isUSD) {
                //conversion via usd
                if (action === 'sell' || action === 'sell_limit' || action === 'sell_stop') {
                    return asset.markupAsk();
                }
                if (action === 'buy' || action === 'buy_limit' || action === 'buy_stop') {
                    return asset.markupBid();
                }
            }

            if (profitMode === 0) {
                if (action === 'sell' || action === 'sell_limit' || action === 'sell_stop') {
                    return asset.markupAsk();
                }
                if (action === 'buy' || action === 'buy_limit' || action === 'buy_stop') {
                    return asset.markupBid();
                }
            } else {
                return asset.markupBid();
            }

        }

        /**
         * Convert currency through list of conversion assets (1 or 2)
         */
        function doConvert(assets, amount, action, profitMode) {
            return assets.reduce(function (acc, assetWrapper) {
                var value = getValue(assetWrapper.asset, action, profitMode, assetWrapper.isUSD);
                return calc(acc, assetWrapper.reverse, value);
            }, amount);
        }

        /**
         * Convert asset rate (direct/reverse)
         */
        function calc(amount, operation, value) {
            return operation
                ? amount * value
                : amount / value
        }

        return {
            find: find,
            currencyConvert: currencyConvert,
            doConvert: doConvert
        }
    }]);
